export enum GtmErrorType {
  INVOICE_ERROR = 'invoice_error',
}

export enum GtmElementCategory {
  ACCOUNT = 'konto',
  TV = 'tv',
  INTERNET = 'internett',
  TELEPHONE = 'telefon',
  INVOICE_OVERVIEW = 'fakturaoversikt',
  INVOICE_POSTPONE = 'utsett_betalingsfristen',
  INVOICE_DETAILS = 'fakturadetaljer',
  AVTALEGIRO = 'avtalegiro',
  TOP_NAVIGATION = 'topp-navigasjon',
  USERS = 'brukere',
  RELOCATION = 'melde_flytting',
  PRIVACY_AND_CONCENTS = 'samtykke_og_kommunikasjon',
  INTERNET_SETTINGS = 'internettinnstillinger',
}

export enum GtmFunnelStepName {
  RELOCATION_LOCATION = 'adresse',
  RELOCATION_DATE = 'dato',
  RELOCATION_SUMMARY = 'oppsummering',
  RELOCATION_RECEIPT = 'kvittering',
}

export enum GtmElementCta {
  INVOICE_DOWNLOAD_PDF = 'last_ned_pdf',
  INVOICE_VIEW_INVOICE_DETAILS = 'se_fakturadetaljer',
  INVOICE_COPY_ACCOUNT_NUMBER = 'kopier_kontonummer',
  INVOICE_COPY_KID = 'kopier_kid_nummer',
  INVOICE_LOAD_OLDER_INVOICES = 'last_eldre_fakturaer',
  INVOICE_CREATE_AVTALEGIRO_LINK = 'opprett_avtalegiro_link',
  INVOICE_CREATE_AVTALEGIRO_CONTINUE = 'fortsett_til_bekreft_avtale',
  INVOICE_POSTPONE_INVOICE_LINK = 'utsett_faktura_link',
  INVOICE_POSTPONE_INVOICE_CONFIRM = 'bekreft_utsettelse',
  USERS_CREATE_USER = 'opprett_ny_bruker',
  USERS_AUTHSERVICE_STEPUP = 'endre_brukerdetaljer',
  USERS_EDIT_USER_CANCEL = 'avbryt_endre_brukerdetaljer',
  USERS_EDIT_USER_SUBMIT = 'lagre_endre_bruker',
  USERS_SEND_ACTIVATION_EMAIL = 'send_epost_aktivering',
  USERS_DELETE_USER = 'slett_bruker',
  USERS_DELETE_USER_CONFIRM = 'bekreft_slett_bruker',
  USERS_DELETE_USER_CANCEL = 'avbryt_slett_bruker',
  RELOCATION_NEXT_STEP = 'neste_steg',
  RELOCATION_PREVIOUS_STEP = 'forrige_steg',
  RELOCATION_SUBMIT = 'send',
  PRIVACY_AND_CONCENTS_GENERAL_MARKETING = 'generell_markedsføring',
  PRIVACY_AND_CONCENTS_RESERVATIONS = 'mine_reservasjoner',
  PRIVACY_AND_CONCENTS_NEWS_AND_OFFERS = 'nyheter_og_tilbud',
  PRIVACY_AND_CONCENTS_UPDATE_CONCENTS = 'lagre_samtykker',
  PRIVACY_AND_CONCENTS_RESERVATIONS_SAVE = 'lagre_samtykker',
  EMAIL_CREATE_NEW = 'opprett_ny_epostkonto',
  EMAIL_CREATE_CANCEL = 'avbryt',
  EMAIL_CREATE_SUBMIT = 'opprett_e-postkonto',
  INTERNET_SETTINGS_HGW_CUSTOMERSERVICE_LINK_BUTTON = 'les_mer_om_hjemmesentralen',
  INTERNET_SETTINGS_HGW_IMAGE = 'bildeswiper_hjemmesentral',
  INTERNET_SETTINGS_SSID_SAVE_BUTTON = 'wifi_lagre_endringer',
  INTERNET_SETTINGS_SSID_TOGGLE = 'wifi_toggle',
  INTERNET_SETTINGS_SSID_COMBINED_BAND = 'wifi_band',
  INTERNET_SETTINGS_SSID_COMBINED_BAND_COMBINE_BUTTON = 'slå_sammen_wifi_båndene',
  INTERNET_SETTINGS_SSID_COMBINED_BAND_SPLIT_BUTTON = 'splitt_wifi_båndene',
  INTERNET_SETTINGS_SSID_COMBINED_BAND_SPLIT_CANCEL_BUTTON = 'avbryt_splitt_wifi-båndene',
  INTERNET_SETTINGS_SSID_COMBINED_BAND_COMBINE_CANCEL_BUTTON = 'avbryt_slå_sammen_wifi-båndene',
  INTERNET_SETTINGS_ADVANCED_SETTINGS = 'avanserte_innstillinger',
  INTERNET_SETTINGS_BRIDGE_MODE = 'bromodus',
  INTERNET_SETTINGS_BRIDGE_MODE_ON_BUTTON = 'slå_på_bromodus',
  INTERNET_SETTINGS_BRIDGE_MODE_OFF_BUTTON = 'slå_av_bromodus',
  INTERNET_SETTINGS_BRIDGE_MODE_CANCEL = 'avbryt_bromodus',
  INTERNET_SETTINGS_TO_WIFI_SETTINGS_LINK = 'tilbake_til_wifi-innstillinger',
  INTERNET_SETTINGS_DEVICELIST_ITEM = 'nettverksenhet',
  INTERNET_SETTINGS_ACCESS_POINT_BUTTON = 'lagre_wifi-punkt',
  INTERNET_SETTINGS_DEVICE_INFO_MANUAL_DOWNLOAD = 'last_ned_brukerveiledning',
  INTERNET_SETTINGS_DEVICE_INFO_CUSTOMERSERVICE_LINK = 'se_hjelpeartikkel',
  INTERNET_SETTINGS_NETWORK_CANCEL = 'avbryt_nettverksinnstillinger',
  INTERNET_SETTINGS_NETWORK_SAVE = 'lagre_endringer_nettverksinnstillinger',
  INTERNET_SETTINGS_FIREWALL_MORE_INFO_LINK = 'les_mer_om_portviderekobling',
  INTERNET_SETTINGS_FIREWALL_ADD_RULE_LINK = 'legg_til_ny_regel',
  INTERNET_SETTINGS_FIREWALL_ADD_RULE_FORM_SUBMIT = 'opprett_regel',
  INTERNET_SETTINGS_FIREWALL_ADD_RULE_FORM_CANCEL = 'avbryt_opprett_regel',
  INTERNET_SETTINGS_FIREWALL_RULE_EDIT = 'endre_regel',
  INTERNET_SETTINGS_FIREWALL_RULE_DELETE = 'slett_regel',
  INTERNET_SETTINGS_HJEM_APP_READ_MORE = 'hjem-app_les_mer',
  PIN_NEW_PIN = 'ny_pin-kode',
  PIN_NEW_PIN_CANCEL = 'avbryt_ny_PIN-kode',
  PIN_NEW_PIN_SAVE = 'lagre_ny_PIN-kode',
  MOVIE_RENTAL_FILTER_MONTH = 'filtrer_tidsperiode',
  STREAMING_SERVICES_GO_TO_FOC = 'gå_til_Velg_ditt_innhold',
  HJEM_APP_DOWNLOAD = 'hjem-app_last_ned',
}

export enum GtmFormName {
  CONCENTS = 'samtykker',
  RESERVASIONS = 'reservasjoner',
  SUBSCRIPTIONS = 'nyheter_og_tilbud',
}

export const getGtmFullUrl = (url: string) => {
  return url.startsWith('http') ? url : window.location.origin + url;
};

export const getAnonymizedCurrentPageUrl = () => {
  return anonymizeUrl(window.location.href);
};

export const anonymizeUrl = (url: string) => {
  // remove query-params and fragment
  let baseUrl = url.split(/[?#]/)[0];

  // remove trailing slash from URL for consistency
  if (baseUrl.length > 1 && baseUrl.endsWith('/')) {
    baseUrl = baseUrl.slice(0, -1);
  }

  // Pattern: number.UUID (e.g. 12345.xxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const combinedPattern = /\/\d+\.[a-z0-9-]+(?=\/|$)/gi;

  // Number ID's in path segment
  const numberPattern = /\/\d+(?=\/|$)/g;

  // UUID v4-format (xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)
  const uuidPattern = /\/[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}(?=\/|$)/gi;

  return baseUrl.replace(combinedPattern, '/{id}').replace(numberPattern, '/{id}').replace(uuidPattern, '/{id}');
};
